<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>Previous Addresses</th>
        </tr>
      </thead>
      <tbody v-for="(address, index) in previousAddresses" :key="index">
        <tr>
          <td>
            {{ formatAddress(address, store.state.lookupsModule?.lookups?.addressUnits) }}
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <next-button
      @click="openAddressModal"
      :text="previousAddresses?.length > 0 ? 'Add Another Address' : 'Add an Address'"
      >Add</next-button
    >
    <address-forms-modal
      ref="addressFormsModal"
      v-if="
        store.state.modal.addressModalActive &&
        store.state.forms?.stipulation?.id === props.stip?.id
      "
      @close="closeAddressModal"
      @success="handleSuccess"
      :stip="stip"
      :applicant="applicant"
      :previousAddresses="previousAddresses"
    />
  </div>
</template>
<script setup lang="ts">
import { useStore } from "vuex";
import { ref, computed } from "vue";
import type { Stipulation } from "@/models/opal";
import NextButton from "@/components/shared/NextButton.vue";
import AddressFormsModal from "@/components/checklist/address-mismatch/AddressFormsModal.vue";
import useHtmlUtilities from "@/use/htmlUtilities";
import type { Applicant, Address } from "@/models/application";
import { formatAddress } from "@/composables/forms/useAddressForm";
import { AddressTypeIds, StipulationStatusIds } from "@/config/constants";

const store = useStore();

interface Props {
  stip: Stipulation;
  applicant: Applicant;
}

const props = withDefaults(defineProps<Props>(), {});

const { decodeHTMLEncodedStr } = useHtmlUtilities();

const emit = defineEmits<{
  (e: "success", updatedStip: Stipulation): void;
}>();

const addressFormsModal = ref<InstanceType<typeof AddressFormsModal> | null>();

const previousAddresses = computed(() => getPreviousAddresses());

function openAddressModal() {
  console.log(`${props.applicant.id} addressMismatch`, props.stip);
  store.state.forms.addressForm.applicantId = props.applicant?.id;
  store.state.forms.addressForm.stipulationId = props.stip?.id;
  store.dispatch("forms/setStipulation", props.stip);
  store.dispatch("modal/openAddressModal");
}

function closeAddressModal() {
  store.dispatch("forms/setStipulation", {});
  store.dispatch("modal/closeAddressModal");
  store.dispatch("forms/getApplicantAddressesAsync", props.applicant?.id);
}

function handleSuccess() {
  const updatedStip = {
    ...props.stip,
    stipulationStatusId: StipulationStatusIds.PENDING,
    stipulationStatusName: "Pending",
  };
	
  emit("success", updatedStip);
  closeAddressModal();
}

function getPreviousAddresses() {
  let applicantAddresses = store.state.appData.applicants
    .find((a: Applicant) => a.id === props.stip?.applicantId)
    ?.addresses?.filter((a: Address) => a.addressTypeId === AddressTypeIds.PreviousAddress);

  if (applicantAddresses && applicantAddresses.length > 0) {
    applicantAddresses.forEach((a: Address) => {
      a.address1 = decodeHTMLEncodedStr(a.address1);
      a.address2 = decodeHTMLEncodedStr(a.address2);
      a.city = decodeHTMLEncodedStr(a.city);
    });
  }

  return applicantAddresses || [];
}
</script>
<style scoped lang="scss">
td.action {
  display: flex;
}

td {
  padding: 3px;
}

.title {
  font-weight: 700;
  font-size: 1.25rem;
}
</style>
